<div class="fullscreen-table-dialog-wrapper">
	<div class="fullscreen-dialog-titlebar">
		<span class="fullscreen-dialog-title">{{ data.title }}</span>
		<button (click)="dialogRef.close()" araButton="icon" matTooltip="Schließen" type="button">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="fullscreen-dialog-body">
		<ng-container *ngTemplateOutlet="data.templateRef; context: { isInDialog: true }"></ng-container>
	</div>
</div>
